/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.1.0
 * @since 1.1.0
 */

import { IGTMOperation } from './index';

/**
 * @description Call Operation on Density List View button Click: Header of tables
 * @param {string} name
 * @param {string} menu
 */
export const onClickDensityListView = (name: string, menu: string): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v239-e1',
    'event_cat': menu,
    'event_name': 'clickElement',
    'event_param': name,
});
